import { render, staticRenderFns } from "./Gonggao.vue?vue&type=template&id=1e522659&scoped=true"
import script from "./Gonggao.vue?vue&type=script&lang=js"
export * from "./Gonggao.vue?vue&type=script&lang=js"
import style0 from "./Gonggao.vue?vue&type=style&index=0&id=1e522659&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e522659",
  null
  
)

export default component.exports